__turbopack_context__.v({
  "className": "nunito_f19d92f-module__ailm_G__className",
  "variable": "nunito_f19d92f-module__ailm_G__variable",
});
